import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import ReadingHistory from './components/ReadingHistory';
import TopStories from './components/TopStories';
import Home from './components/Home';
import NewStories from './components/NewStories';
import OngoingStories from './components/OngoingStories';
import ComingSoonStories from './components/ComingSoonStories';
import CompletedStories from './components/CompletedStories';
import GenreStories from './components/GenreStories';
import ComicDetails from './components/ComicDetails';
import ChapterDetails from './components/ChapterDetails';
import Footer from './components/Footer';
import Login from './components/Login';
import Signup from './components/Signup';
import './styles.css';

const MainContent = ({ searchValue, showReadingHistory, showTopStories }) => {
  const location = useLocation();

  return (
    <div className="main-content">
      <Routes>
        <Route path="/" element={<Home searchValue={searchValue} />} />
        <Route path="/new" element={<NewStories searchValue={searchValue} />} />
        <Route path="/ongoing" element={<OngoingStories searchValue={searchValue} />} />
        <Route path="/coming-soon" element={<ComingSoonStories searchValue={searchValue} />} />
        <Route path="/completed" element={<CompletedStories searchValue={searchValue} />} />
        <Route path="/genres/:slug" element={<GenreStories />} />
        <Route path="/comics/:comicId" element={<ComicDetails />} />
        <Route path="/chapters/:chapterId" element={<ChapterDetails />} />
        <Route path="/search" element={<SearchBar searchValue={searchValue} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>

      {/* Chỉ hiển thị khi không ở trang ChapterDetails, Login, và Signup */}
      {
        !(
          location.pathname.includes('/chapters/') ||
          location.pathname.includes('/login') ||
          location.pathname.includes('/signup')
        ) && (
          <div className="right-container">
            {showReadingHistory && <ReadingHistory/>}
            {showTopStories && <TopStories/>}
          </div>
        )
      }

    </div>
  );
};

const App = () => {
  const [searchValue, setSearchValue] = React.useState("");
  const [showReadingHistory, setShowReadingHistory] = React.useState(true);
  const [showTopStories, setShowTopStories] = React.useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 560) {
        setShowReadingHistory(false);
        setShowTopStories(false);
      } else {
        setShowReadingHistory(true);
        setShowTopStories(true);
      }
    };

    // Thêm listener cho resize
    window.addEventListener('resize', handleResize);
    handleResize(); // Gọi ngay để xác định trạng thái ban đầu

    // Cleanup listener khi component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <Header searchValue={searchValue} setSearchValue={setSearchValue} />
      <MainContent searchValue={searchValue} showReadingHistory={showReadingHistory} showTopStories={showTopStories} />
      <Footer />
    </Router>
  );
};

export default App;
